import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { IInvoiceAddress } from '../../interfaces/invoice-address';
import { IPageResult } from '../../interfaces/page-result';
import { InvoiceAddressService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IInvoiceAddressFilter } from '../../interfaces/invoice-address-filter';
import { OrganisationsService } from '../../services';
import { UserService } from '../../services';
import { flatten } from '../../utils/flatten';
import { SelectItem, LazyLoadEvent, ConfirmationService } from 'primeng';
import { IDepartment } from '../../interfaces/department';
import { IInvoiceAddressHistory } from '../../interfaces/invoice-address-history';
import { getCombinedParameters } from '../../utils/getCombinedParameters';
import { tryParseInt } from '../../utils/tryParseInt';

@Component({
  templateUrl: './invoice-address-list.component.html',
  styleUrls: ['./invoice-address-list.component.scss', './invoice-address.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceAddressListComponent implements OnInit {
  public page: IPageResult<IInvoiceAddress> = {
    items: [],
    total: 0,
  };
  public loading: boolean;
  public filterVal: IInvoiceAddressFilter;
  public filter: Subject<IInvoiceAddressFilter>;
  public selectedInvoiceAddress: IInvoiceAddress = null;
  public isVmeMode: boolean;
  public customerorgId: number;
  public currentUserOrgTypeId: number;
  public currentUserOrgId: number;
  public invoiceAddressId: number;
  public renderView: boolean = false;
  public organisationsList: SelectItem[];
  public invoiceAddressHistory: IInvoiceAddressHistory[];

  displayDialog: boolean;
  displayInvoiceUsageDialog: boolean;
  showHistory: boolean;

  sortOptions: SelectItem[];
  sortKey: string;
  sortField: string;
  sortOrder: number;

  constructor(
    private invoiceAddressService: InvoiceAddressService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private organisationService: OrganisationsService,
  ) {}

  ngOnInit() {
    getCombinedParameters(this.route).subscribe((params) => {
      this.filter = new Subject<IInvoiceAddressFilter>();
      this.customerorgId = tryParseInt(params['orgid']) as number;
      this.invoiceAddressId = tryParseInt(params['id']) as number;
      this.userService.getCurrentUserOrg().then((res) => {
        this.currentUserOrgId = res.id;
        this.currentUserOrgTypeId = res.organisationTypeId;
        this.isVmeMode = res.organisationTypeId == 1;
        if (!this.isVmeMode) {
          this.customerorgId = this.currentUserOrgId;
        }
        if (this.customerorgId) {
          this.filterVal.filters.organisationId.value = this.customerorgId;
        } else if (this.invoiceAddressId) {
          this.filterVal.filters.id.value = this.invoiceAddressId;
        }
        // subscribe to filter changes with a debounce time
        this.filter.pipe(debounceTime(500)).subscribe((f) => {
          this.load(f);
          this.filterVal = f;
        });
        this.filter.next(this.filterVal);

        //this.organisationFilter.pipe(debounceTime(500)).subscribe(o => { this.loadOrganisations(o); this.organisationFilterVal = o; });
      });

      // set default filter
      this.initDefaultFilter();
      this.sortOptions = [
        { label: 'Company Name', value: 'invoicecompanyname', icon: 'pi pi-sort-down' },
        { label: 'Company Name', value: '!invoicecompanyname', icon: 'pi pi-sort-up' },
        { label: 'Approved', value: '!isapproved', icon: 'pi pi-check' },
        { label: 'Not approved', value: 'isapproved', icon: 'pi pi-ban' },
      ];
    });
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: null,
      sortOrder: 1,
      filters: {
        id: { value: null },
        isApproved: { value: null },
        organisationId: { value: null },
      },
    };
  }

  onOrganisationChange(orgId: number) {
    this.filterVal.filters.organisationId.value = orgId;
    this.loading = true;
    this.filter.next(this.filterVal);
  }

  load(filter: IInvoiceAddressFilter) {
    this.loading = true;
    this.invoiceAddressService
      .getPage(flatten(filter))
      .then((result) => {
        this.page.items = result.items;
        this.page.total = result.total;
        this.loading = false;
        console.log(this.page);
      })
      .catch((error) => {
        this.loading = false;
        console.log('error getting invoice addresses ' + JSON.stringify(error));
      });
  }

  onLazyLoad(event: LazyLoadEvent) {
    //this.loading = true;
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filter.next(this.filterVal);
  }

  selectInvoiceAddress(event: Event, invoiceAddress: IInvoiceAddress) {
    this.selectedInvoiceAddress = invoiceAddress;
    this.displayDialog = true;
    event.preventDefault();
  }

  onSortChange(event: any) {
    let value = event.value;
    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
    this.loading = true;
    this.filterVal.sortField = this.sortField;
    this.filterVal.sortOrder = this.sortOrder;
    this.filter.next(this.filterVal);
  }

  modifyInvoiceAddress(event: any, data) {
    var param: any = { id: data.id };
    if (this.filterVal.filters.organisationId.value) {
      param.orgid = this.filterVal.filters.organisationId.value;
    }
    this.router.navigate(['app/invoiceaddress'], { queryParams: param });
  }

  createNew(event) {
    this.router.navigate(['app/invoiceaddress']);
  }

  onDialogHide() {
    this.selectedInvoiceAddress = null;
  }

  dissasociateInvoiceAddressOrg(event: any, org, invoiceAddress) {
    this.invoiceAddressService.update(invoiceAddress.id, invoiceAddress);
  }

  confirmInvoiceAddressAction(message: string, callbackFunction: Function) {
    this.confirmationService.confirm({
      message: message,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      key: 'invoice-address-action-dialog',
      accept: () => {
        if (callbackFunction) callbackFunction();
      },
      reject: () => {},
    });
  }

  dissasociateInvoiceAddressDept(event: any, dept: IDepartment, invoiceAddress: IInvoiceAddress) {
    this.confirmInvoiceAddressAction(
      'Are you sure you want to remove this invoice address from this dept?',
      () => {
        // get the dept
        this.organisationService
          .getDepartment(dept.id)
          .then((res) => {
            if (invoiceAddress.id == dept.invoiceAddressId) {
              //make the modification
              dept.invoiceAddressId = null;
              //update the dept
              this.organisationService.updateDepartment(dept).then((res) => {
                let iaIndex = this.page.items.findIndex((x) => x.id == invoiceAddress.id);
                if (iaIndex > -1) {
                  let referenceDeptIndex = this.page.items[iaIndex].customerDepartments.findIndex(
                    (x) => x.id == dept.id,
                  );
                  if (referenceDeptIndex > -1) {
                    this.page.items[iaIndex].customerDepartments.splice(referenceDeptIndex, 1);
                  }
                }
              });
            } else {
              // notify of non-matching entities
              console.log('Requested invoice address does not match current invoice address');
            }
          })
          .catch((error) => {
            console.log(`error updating department ${error}`);
          });
      },
    );
  }

  delete(event: any, invoiceAddress: IInvoiceAddress) {
    this.confirmInvoiceAddressAction(
      'Are you sure you want to remove this invoice address?',
      () => {
        // get the dept
        this.invoiceAddressService
          .delete(invoiceAddress.id)
          .then((res) => {
            this.load(this.filterVal);
          })
          .catch((error) => {
            console.log(`error deleting invoice address ${error}`);
          });
      },
    );
  }

  approve(event: any, ia: IInvoiceAddress) {
    this.invoiceAddressService.approve(ia.id).then((res) => {
      ia.isApproved = true;
    });
  }

  disapprove(event: any, ia: IInvoiceAddress) {
    this.invoiceAddressService.unapprove(ia.id).then((res) => {
      ia.isApproved = false;
    });
  }

  getHistory(event: any, ia: IInvoiceAddress) {
    this.invoiceAddressHistory = [];
    this.invoiceAddressService.getHistory(ia.id).then((res) => {
      console.log('Result returned: ' + JSON.stringify(res));
      this.invoiceAddressHistory = res;
      this.showHistory = true;
    });
  }

  hasValue(item: string) {
    return item != null && item != undefined && item != null && item.trim() != '';
  }
}
